export default "__VITE_ASSET__DgyrGnGl__"